import alertModal from './alertModal.vue'

export default alertModal
